import SortableController from "./sortable_controller";
import Sortable from "sortablejs";

export default class extends SortableController {
  protected getSortableOptions(): Sortable.Options {
    const baseOptions = super.getSortableOptions();

    return {
      ...baseOptions,
      onMove: this.onMove.bind(this),
      filter: '[data-sortable-disabled="true"]',
      preventOnFilter: true,
    };
  }

  protected onMove(event: Sortable.MoveEvent): boolean | -1 | 1 {
    console.log("workflow onMove called");

    // Check if the dragged element is disabled
    if (event.dragged.dataset.sortableDisabled === "true") {
      console.log("Dragged element is disabled");
      return false;
    }

    // Get the dragged element's current index
    const draggedIndex = Array.from(this.element.children).indexOf(
      event.dragged,
    );

    // Get the related element's index (where we're trying to drop)
    const relatedIndex = Array.from(this.element.children).indexOf(
      event.related,
    );

    console.log(
      `Dragged index: ${draggedIndex}, Related index: ${relatedIndex}, willInsertAfter: ${event.willInsertAfter}`,
    );

    // Don't allow the first item (index 0) to be moved anywhere
    if (draggedIndex === 0) {
      console.log("PREVENT: Cannot move first item");
      return false;
    }

    // Don't allow anything to be moved to position 0 (before first item)
    if (relatedIndex === 0 && !event.willInsertAfter) {
      console.log("PREVENT: Cannot move item to position 0");
      return false;
    }

    // Allow all other moves
    console.log("ALLOW: Move is valid");
    return true;
  }

  protected async onEnd(event: Sortable.SortableEvent) {
    // Only proceed with the update if the move was valid
    // The onMove method will have already prevented invalid moves,
    // but we can add additional checks here if needed
    if (event.oldIndex === event.newIndex) return;

    // Call the parent's onEnd method to handle the actual update
    await super.onEnd(event);
  }

  protected getUpdatePayload(event: Sortable.SortableEvent): object {
    return {
      workflow_step: {
        position: event.newIndex! + 1,
      },
    };
  }
}
